import { FincredibleLogo, LoadingSpinner } from '../LoadingSpinner';
import useCustomization from '../../hooks/useCustomization';
import { CustomizationKey } from '../../contexts/CustomizationsContext';

const FINCREDIBLE_XS2A_LOADING_TEXT_KEY: CustomizationKey = 'FINCREDIBLE_XS2A_LOADING_TEXT';

export const SessionLoader = () => {
	const title = useCustomization(FINCREDIBLE_XS2A_LOADING_TEXT_KEY);

	return (
		<LoadingSpinner title={title}>
			<FincredibleLogo />
		</LoadingSpinner>
	);
};
